module.exports = __webpack_public_path__ + "static/img/friend11.5461887.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend11.jpg
// module id = avte
// module chunks = 1